var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regulation-page mt-4"},[_c('app-page-header',{attrs:{"title":"Regulamento","subtitle":_vm.regulation.title}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.regulation.text)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }